var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "currentColor",
    "aria-label": "Video Abspielen",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1c12.703 0 23 10.297 23 23S36.703 47 24 47 1 36.703 1 24 11.297 1 24 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M24 1c12.703 0 23 10.297 23 23S36.703 47 24 47 1 36.703 1 24 11.297 1 24 1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M32.5 24a1 1 0 0 1-.455.839l-11 7.144a1.001 1.001 0 0 1-1.545-.84V16.857a1 1 0 0 1 1.545-.839l11 7.144.1.075A1 1 0 0 1 32.5 24Z"
  })));
};
export default SvgPlay;